module.exports = __webpack_public_path__ + "static/img/organization.64fa960a.png";